import { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, testid = "image-uploader" }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const r = await api.post("/uploads/image", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(r.data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  if (value) {
    return (
      <div className="relative inline-block border border-zinc-200 group" data-testid={testid}>
        <img src={fileUrl(value)} alt="Upload" className="w-32 h-32 object-cover" />
        <button
          type="button"
          onClick={() => onChange(null)}
          className="absolute top-1 right-1 w-6 h-6 bg-black text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          data-testid={`${testid}-remove`}
        >
          <X size={14} strokeWidth={2} />
        </button>
      </div>
    );
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => upload(e.target.files?.[0])}
        data-testid={`${testid}-input`}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={uploading}
        className="border border-dashed border-zinc-300 bg-zinc-50 hover:bg-zinc-100 transition-colors w-32 h-32 flex flex-col items-center justify-center gap-2 text-zinc-500 text-xs"
        data-testid={`${testid}-button`}
      >
        {uploading ? <Loader2 size={20} strokeWidth={1.5} className="animate-spin" /> : <Upload size={20} strokeWidth={1.5} />}
        {uploading ? "Uploading..." : "Upload photo"}
      </button>
    </>
  );
}
